import styled from 'styled-components';

const ImageContainer = styled.div`
  height: 38px;
  width: 38px;
  margin-right: 11px;

  ${Styles.mobileTiny`
    margin-right: 8px;  
  `}

  ${Styles.desktop`
    height: 44px;
    width: 44px;
    margin-right: 22px;
  `}

  :empty {
    display: none;
  }
`;

export default ImageContainer;
